import { ProductListingProps } from "../types/ProductList";

type BackendProducts = {
  id: string;
  priceInCents: number;
  availability: string;
  disabled: boolean;
  name: string;
  imageMasterUrl: string;
  discontinuedDate?: string | null;
  createdAt: string;
  abv?: string;
  ibu?: string;
};

export const mapProducts = (
  backendProducts: BackendProducts[]
): ProductListingProps[] => {
  return backendProducts.map((product) => ({
    id: product.id,
    price: (product.priceInCents / 100).toString(), // Convert cents to dollars
    // alcoholContent: `${product.alcoholPercent}%`,
    isOutOfStock: product.availability == "OUT_OF_STOCK",
    disabled: product.disabled,
    name: product.name,
    images: product.imageMasterUrl,
    date: product.createdAt,
    abv: product.abv,
    ibu: product.ibu,
  }));
};

//getById
interface BackendProductImage {
  fileName: string;
  url: string;
}

type BackendProduct = {
  id: string;
  priceInCents: number;
  // alcoholPercent: number;
  abv?: string;
  ibu?: string;
  discountedPriceInCents: number;
  disabled: boolean;
  discontinuedDate: string | null;
  organizationId: string;
  categoryId: string;
  name: string;
  description: string;
  primaryButtonTitle: string;
  secondaryButtonTitle: string;
  imageMasterUrl: string;
  images: BackendProductImage[];
  availability: string;
  quantity_20L: number;
  quantity_30L: number;
  quantity_50L: number;
};

export const mapProduct = (backendData: BackendProduct) => {
  const product = backendData;
  return {
    id: product.id,
    name: product.name,
    price: product.priceInCents / 100,
    Description: product.description,
    images: product.images.map((img: BackendProductImage) => img.url),
    mainImage: product.imageMasterUrl,
    isOutOfStock: product.availability == "OUT_OF_STOCK",
    disabled: product.disabled,
    availableQuantity20L: +product.quantity_20L,
    availableQuantity30L: +product.quantity_30L,
    availableQuantity50L: +product.quantity_50L,
    flavor: "N/A", // Backend doesn't provide flavor
    abv: product.abv,
    ibu: product.ibu,
  };
};
